// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_auth_recording.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "./buf/validate/validate_pb";
import type { PastRoomInfo } from "./plugnmeet_auth_room_pb";
import { file_plugnmeet_auth_room } from "./plugnmeet_auth_room_pb";
import type { RecordingMetadata } from "./plugnmeet_recording_pb";
import { file_plugnmeet_recording } from "./plugnmeet_recording_pb";
import type { StatusCode } from "./plugnmeet_common_api_pb";
import { file_plugnmeet_common_api } from "./plugnmeet_common_api_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_auth_recording.proto.
 */
export const file_plugnmeet_auth_recording: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_plugnmeet_auth_room, file_plugnmeet_recording, file_plugnmeet_common_api]);

/**
 * @generated from message plugnmeet.FetchRecordingsReq
 */
export type FetchRecordingsReq = Message<"plugnmeet.FetchRecordingsReq"> & {
  /**
   * @generated from field: repeated string room_ids = 1;
   */
  roomIds: string[];

  /**
   * To get information about a particular session
   *
   * @generated from field: optional string room_sid = 2;
   */
  roomSid?: string | undefined;

  /**
   * @generated from field: uint32 from = 3;
   */
  from: number;

  /**
   * @generated from field: uint32 limit = 4;
   */
  limit: number;

  /**
   * @generated from field: string order_by = 5;
   */
  orderBy: string;
};

/**
 * Describes the message plugnmeet.FetchRecordingsReq.
 * Use `create(FetchRecordingsReqSchema)` to create a new message.
 */
export const FetchRecordingsReqSchema: GenMessage<FetchRecordingsReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_recording, 0);

/**
 * @generated from message plugnmeet.RecordingInfo
 */
export type RecordingInfo = Message<"plugnmeet.RecordingInfo"> & {
  /**
   * @generated from field: string record_id = 1;
   */
  recordId: string;

  /**
   * @generated from field: string room_id = 2;
   */
  roomId: string;

  /**
   * @generated from field: string room_sid = 3;
   */
  roomSid: string;

  /**
   * @generated from field: string file_path = 4;
   */
  filePath: string;

  /**
   * @generated from field: float file_size = 5;
   */
  fileSize: number;

  /**
   * @generated from field: int64 creation_time = 6 [jstype = JS_STRING];
   */
  creationTime: string;

  /**
   * @generated from field: int64 room_creation_time = 7 [jstype = JS_STRING];
   */
  roomCreationTime: string;

  /**
   * @generated from field: optional plugnmeet.RecordingMetadata metadata = 8;
   */
  metadata?: RecordingMetadata | undefined;
};

/**
 * Describes the message plugnmeet.RecordingInfo.
 * Use `create(RecordingInfoSchema)` to create a new message.
 */
export const RecordingInfoSchema: GenMessage<RecordingInfo> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_recording, 1);

/**
 * @generated from message plugnmeet.FetchRecordingsResult
 */
export type FetchRecordingsResult = Message<"plugnmeet.FetchRecordingsResult"> & {
  /**
   * @generated from field: int64 total_recordings = 1 [jstype = JS_STRING];
   */
  totalRecordings: string;

  /**
   * @generated from field: uint32 from = 2;
   */
  from: number;

  /**
   * @generated from field: uint32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: string order_by = 4;
   */
  orderBy: string;

  /**
   * @generated from field: repeated plugnmeet.RecordingInfo recordings_list = 5;
   */
  recordingsList: RecordingInfo[];
};

/**
 * Describes the message plugnmeet.FetchRecordingsResult.
 * Use `create(FetchRecordingsResultSchema)` to create a new message.
 */
export const FetchRecordingsResultSchema: GenMessage<FetchRecordingsResult> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_recording, 2);

/**
 * @generated from message plugnmeet.FetchRecordingsRes
 */
export type FetchRecordingsRes = Message<"plugnmeet.FetchRecordingsRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;

  /**
   * @generated from field: plugnmeet.FetchRecordingsResult result = 4;
   */
  result?: FetchRecordingsResult | undefined;
};

/**
 * Describes the message plugnmeet.FetchRecordingsRes.
 * Use `create(FetchRecordingsResSchema)` to create a new message.
 */
export const FetchRecordingsResSchema: GenMessage<FetchRecordingsRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_recording, 3);

/**
 * @generated from message plugnmeet.RecordingInfoReq
 */
export type RecordingInfoReq = Message<"plugnmeet.RecordingInfoReq"> & {
  /**
   * @generated from field: string record_id = 1;
   */
  recordId: string;
};

/**
 * Describes the message plugnmeet.RecordingInfoReq.
 * Use `create(RecordingInfoReqSchema)` to create a new message.
 */
export const RecordingInfoReqSchema: GenMessage<RecordingInfoReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_recording, 4);

/**
 * @generated from message plugnmeet.RecordingInfoRes
 */
export type RecordingInfoRes = Message<"plugnmeet.RecordingInfoRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;

  /**
   * @generated from field: plugnmeet.RecordingInfo recording_info = 4;
   */
  recordingInfo?: RecordingInfo | undefined;

  /**
   * @generated from field: plugnmeet.PastRoomInfo room_info = 5;
   */
  roomInfo?: PastRoomInfo | undefined;
};

/**
 * Describes the message plugnmeet.RecordingInfoRes.
 * Use `create(RecordingInfoResSchema)` to create a new message.
 */
export const RecordingInfoResSchema: GenMessage<RecordingInfoRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_recording, 5);

/**
 * @generated from message plugnmeet.DeleteRecordingReq
 */
export type DeleteRecordingReq = Message<"plugnmeet.DeleteRecordingReq"> & {
  /**
   * @generated from field: string record_id = 1;
   */
  recordId: string;
};

/**
 * Describes the message plugnmeet.DeleteRecordingReq.
 * Use `create(DeleteRecordingReqSchema)` to create a new message.
 */
export const DeleteRecordingReqSchema: GenMessage<DeleteRecordingReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_recording, 6);

/**
 * @generated from message plugnmeet.DeleteRecordingRes
 */
export type DeleteRecordingRes = Message<"plugnmeet.DeleteRecordingRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;
};

/**
 * Describes the message plugnmeet.DeleteRecordingRes.
 * Use `create(DeleteRecordingResSchema)` to create a new message.
 */
export const DeleteRecordingResSchema: GenMessage<DeleteRecordingRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_recording, 7);

/**
 * @generated from message plugnmeet.GetDownloadTokenReq
 */
export type GetDownloadTokenReq = Message<"plugnmeet.GetDownloadTokenReq"> & {
  /**
   * @generated from field: string record_id = 1;
   */
  recordId: string;
};

/**
 * Describes the message plugnmeet.GetDownloadTokenReq.
 * Use `create(GetDownloadTokenReqSchema)` to create a new message.
 */
export const GetDownloadTokenReqSchema: GenMessage<GetDownloadTokenReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_recording, 8);

/**
 * @generated from message plugnmeet.GetDownloadTokenRes
 */
export type GetDownloadTokenRes = Message<"plugnmeet.GetDownloadTokenRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;

  /**
   * @generated from field: optional string token = 4;
   */
  token?: string | undefined;
};

/**
 * Describes the message plugnmeet.GetDownloadTokenRes.
 * Use `create(GetDownloadTokenResSchema)` to create a new message.
 */
export const GetDownloadTokenResSchema: GenMessage<GetDownloadTokenRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_recording, 9);

/**
 * @generated from message plugnmeet.UpdateRecordingMetadataReq
 */
export type UpdateRecordingMetadataReq = Message<"plugnmeet.UpdateRecordingMetadataReq"> & {
  /**
   * @generated from field: string record_id = 1;
   */
  recordId: string;

  /**
   * @generated from field: plugnmeet.RecordingMetadata metadata = 2;
   */
  metadata?: RecordingMetadata | undefined;
};

/**
 * Describes the message plugnmeet.UpdateRecordingMetadataReq.
 * Use `create(UpdateRecordingMetadataReqSchema)` to create a new message.
 */
export const UpdateRecordingMetadataReqSchema: GenMessage<UpdateRecordingMetadataReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_recording, 10);

/**
 * @generated from message plugnmeet.UpdateRecordingMetadataRes
 */
export type UpdateRecordingMetadataRes = Message<"plugnmeet.UpdateRecordingMetadataRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;
};

/**
 * Describes the message plugnmeet.UpdateRecordingMetadataRes.
 * Use `create(UpdateRecordingMetadataResSchema)` to create a new message.
 */
export const UpdateRecordingMetadataResSchema: GenMessage<UpdateRecordingMetadataRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_recording, 11);

/**
 * @generated from message plugnmeet.MergeRecordingsByRoomSession
 */
export type MergeRecordingsByRoomSession = Message<"plugnmeet.MergeRecordingsByRoomSession"> & {
  /**
   * Merge all recordings from a single room session.
   *
   * @generated from field: string room_sid = 1;
   */
  roomSid: string;

  /**
   * Optionally exclude some recordings from the merge.
   *
   * @generated from field: repeated string exclude_recording_ids = 2;
   */
  excludeRecordingIds: string[];
};

/**
 * Describes the message plugnmeet.MergeRecordingsByRoomSession.
 * Use `create(MergeRecordingsByRoomSessionSchema)` to create a new message.
 */
export const MergeRecordingsByRoomSessionSchema: GenMessage<MergeRecordingsByRoomSession> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_recording, 12);

/**
 * @generated from message plugnmeet.MergeRecordingsByIds
 */
export type MergeRecordingsByIds = Message<"plugnmeet.MergeRecordingsByIds"> & {
  /**
   * The room_id that all recording_ids belong to.
   *
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * A list of recording IDs to merge.
   * All recordings must belong to the specified room_id, but can be from different sessions.
   * The final video will be generated by appending recordings in the order they are provided here.
   *
   * @generated from field: repeated string recording_ids = 2;
   */
  recordingIds: string[];
};

/**
 * Describes the message plugnmeet.MergeRecordingsByIds.
 * Use `create(MergeRecordingsByIdsSchema)` to create a new message.
 */
export const MergeRecordingsByIdsSchema: GenMessage<MergeRecordingsByIds> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_recording, 13);

/**
 * @generated from message plugnmeet.MergeRecordingsReq
 */
export type MergeRecordingsReq = Message<"plugnmeet.MergeRecordingsReq"> & {
  /**
   * @generated from oneof plugnmeet.MergeRecordingsReq.merge_scope
   */
  mergeScope: {
    /**
     * Merge recordings based on a single room session.
     *
     * @generated from field: plugnmeet.MergeRecordingsByRoomSession by_session = 1;
     */
    value: MergeRecordingsByRoomSession;
    case: "bySession";
  } | {
    /**
     * Merge a specific list of recordings from the same room.
     *
     * @generated from field: plugnmeet.MergeRecordingsByIds by_ids = 2;
     */
    value: MergeRecordingsByIds;
    case: "byIds";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message plugnmeet.MergeRecordingsReq.
 * Use `create(MergeRecordingsReqSchema)` to create a new message.
 */
export const MergeRecordingsReqSchema: GenMessage<MergeRecordingsReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_recording, 14);

